import { isVariableInLS } from '@/shared/lib/isVariableInLS';

export const IS_ENV_SELECTOR = isVariableInLS('isEnvSelector');
export const IS_REACT_QUERY_TOOLS = isVariableInLS('isReactQueryTools');
export const IS_MAINTENANCE_DISABLED = isVariableInLS('maintenanceOff');
